// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var UserForm$ReactHooksTemplate = require("./UserForm.res.js");

function UserProfile(props) {
  var match = React.useState(function (param) {
        return "FetchingUser";
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  Curry._1(setState, (function (param) {
                          return "Error";
                        }));
                  return Promise.resolve();
                }), Js_promise.then_((function (user) {
                      Curry._1(setState, (function (param) {
                              return {
                                      TAG: "Available",
                                      _0: user
                                    };
                            }));
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/users/current", (function (param) {
                          return Json_decode.field("user", User$ReactHooksTemplate.decode, param);
                        }))));
        }), []);
  if (typeof state !== "object") {
    if (state === "FetchingUser") {
      return JsxRuntime.jsx("p", {
                  children: "Loading profile...",
                  className: "p-30-px"
                });
    } else {
      return JsxRuntime.jsx("p", {
                  children: "Unable to load your profile. Please try again.",
                  className: "p-30-px"
                });
    }
  } else {
    return JsxRuntime.jsx(UserForm$ReactHooksTemplate.make, {
                user: state._0,
                profile: true
              });
  }
}

var make = UserProfile;

exports.make = make;
/* react Not a pure module */
